import { connectRedux } from '@om1/platform-utils'
import { CohortState, CriterionNode, cohortBlocksEditActions } from '../../../state'
import { findNode } from '../../../state/edit/blocks/cohort-blocks-edit-reducer'
import { SpecialtyEditDialogComponent } from './SpecialtyEditDialogComponent'

export function createSpecialtyEditDialogComponent<TState extends { cohort: CohortState }>() {
    return connectRedux(
        SpecialtyEditDialogComponent,
        (state: TState) => {
            const nodeId = state.cohort.edit.blocks.ui.specialtyEditDialog.target?.nodeId

            return {
                criteria: nodeId ? (findNode(state.cohort.edit.blocks.tree, nodeId) as CriterionNode) : undefined
            }
        },
        cohortBlocksEditActions
    )
}

export type SpecialtyEditDialog = ReturnType<typeof createSpecialtyEditDialogComponent>
